import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  MenuController,
  ModalController,
  NavParams,
  PopoverController,
} from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { format, parseISO } from 'date-fns';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-memorandum-revisi',
  templateUrl: './memorandum-revisi.component.html',
  styleUrls: ['./memorandum-revisi.component.css'],
})
export class MemorandumRevisiComponent implements OnInit {
  load: boolean = false;
  saving: any = {};
  idData: any;

  detData: any = {};
  det: any;
  tampilData: boolean = false;
  keterangan: any = '';
  dateValue2: any = '';
  expdate: any = '';
  form: any;
  token: any = '';
  baseUrl: any = '';

  dele: any = {};
  id: any = '';
  @ViewChild('popoverModalStart', { static: false }) popoverModalStart!: HTMLIonModalElement;


  constructor(
    public popoverController: PopoverController,
    public modalController: ModalController,
    public menuCtrl: MenuController,
    public route: Router,
    public http: HttpClient,
    public loadingctrl: LoadingController,
    public alertctrl: AlertController,
    public util: UtilService,
    public activatedRoute: ActivatedRoute,
    public actionSheetController: ActionSheetController,
    public navParams: NavParams,
    public api: ApiService
  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.id = this.navParams.data.id;
    // this.provision_key = environment.restURL.provision_key;
    // this.client_id = environment.restURL.client_id;
    // this.client_secret = environment.restURL.client_secret;
    // this.grant_type = environment.restURL.grant_type;
    // this.authUrl = environment.restURL.authUrl;
  }

  ngOnInit(): void {}

   formatDateStart(value: any) {
    this.expdate= format(parseISO(value), 'yyyy-MM-dd, hh:mm');
    this.popoverModalStart?.dismiss();
  }

  formatDate(value: any) {
    return format(parseISO(value), 'yyyy-MM-dd, hh:mm');
  }

  submit() {
    this.form = JSON.stringify({
      keterangan: this.keterangan,
      reschedule_dtm: this.expdate,
    });
    console.log('FORM', this.form);
    this.token = localStorage.getItem('usertoken') || '';
    let hd = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.token,
    };
    this.load = true;
    this.http
      .post(
        this.baseUrl + 'backoffice/credit-analyst/memo/reject/' + this.id,
        this.form,
        { headers: hd }
      )
      .subscribe(
        (data) => {
          this.dele = data;
          console.log('dele', this.dele);
          if (this.dele.error == 0) {
            this.load = false;
            this.util.showToast(this.dele.message, 'success', 'bottom');
            this.api.dismissData('', 'confirm');
          } else {
            this.load = false;
            this.util.showToast(this.dele.message, 'danger', 'bottom');
          }
        },
        (error) => {
          this.load = false;
          console.log('error', error);
          if (error.error.error == 'invalid_token' || error.status == 401) {
            this.fungsilogout();
          } else {
            this.util.showToast(error.error.message, 'danger', 'bottom');
          }
        }
      );
  }

  fungsilogout() {
    this.util.showToast(
      'Sesi anda berakhir, Silahkan Login Kembali',
      'success',
      'bottom'
    );
    localStorage.removeItem('usertoken');
    localStorage.removeItem('user');
    this.route.navigate(['./login']);
    window.location.reload();
  }
}
